export const styles = (theme) => ({
  titleWrapper: {
    padding: theme.spacing(3),
    position: 'relative',
    minWidth: 500,
  },
  title: {
    color: '#4a4a4a',
    fontSize: '1.5em',
    fontFamily: 'AvenirNext-Medium',
  },
  dialog: {
    fontFamily: 'AvenirNext'
  },
  controlWrapper: {
    padding: theme.spacing(1, 0),
  },
  label: {
    fontWeight: 'bolder',
    padding: theme.spacing(1, 0),
  },
  tableHeadCell: {
    backgroundColor: '#f4f4f4',
    fontWeight: 'bolder',
  },
  smallTableHeadCell: {
    fontSize: 12,
    backgroundColor: '#f4f4f4',
    fontWeight: 'bolder',
  },
  smallTableCell: {
    fontSize: 12,
  },
  changed: {
    backgroundColor: '#fff8e2',
  },
  closeIcon: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    padding: 0,
  },
  actionsWrapper: {
    padding: theme.spacing(1, 3, 2),
  },
  button: {
    fontFamily: 'AvenirNext-DemiBold',
    minWidth: 100,
  },
  okButton: {
    backgroundColor: '#4abc4e',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#328634',
    }
  },
  error: {
    color: '#f00',
    fontWeight: 700,
  },
  blueText: {
    color: '#327df5',
  },
  redText: {
    color: '#f00',
  }
})
